export const isValidDisplayName = (displayName: string): boolean => {
  if (displayName.length === 0) {
    return true;
  }
  return new RegExp(/^[\w\-_.\s]+$/s).test(displayName);
};
